var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 18C36 8.05887 27.9411 0 18 0C8.05888 0 0 8.05887 0 18C0 27.9411 8.05888 36 18 36C27.9411 36 36 27.9411 36 18ZM33.011 19.0724C33.6038 19.0724 34.0414 19.554 33.9781 20.1438C33.9781 20.1438 34.0245 19.7958 33.977 20.1522C32.9249 28.0372 26.1728 34.1194 18 34.1194C9.0975 34.1194 1.8806 26.9025 1.8806 18C1.8806 9.0975 9.0975 1.8806 18 1.8806C26.1704 1.8806 32.921 7.95932 33.9761 15.8409C34.0241 16.1995 33.9783 15.858 33.9783 15.858C34.0368 16.4486 33.6077 16.9274 33.011 16.9274L13.5848 16.9274C13.2888 16.9274 13.2185 16.7583 13.4264 16.551L18.7369 11.253C19.7503 10.2421 18.2307 8.72512 17.2172 9.73646L9.79659 17.077C9.26949 17.5974 9.2716 18.441 9.80409 18.964L17.2172 26.2634C18.2307 27.2747 19.7503 25.7582 18.7369 24.7469L13.4264 19.4488C13.2179 19.2409 13.2868 19.0724 13.5848 19.0724L33.011 19.0724Z",
    fill: "#1B224C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.5fb48d34ec588da40c42163f579ea116.svg";
export { ForwardRef as ReactComponent };